import { MODULE } from "./sort.actionTypes";

export const getSort = (state) => state.getIn([MODULE, "sort"]);

// export const getFormattedSort = (state) => {
//   const sort = getSort(state);

//   return sort
//     .filter((s) => s.id)
//     .map((s) => ({ field_name: s.id, sort_by: s.desc ? "desc" : "asc" }));
// };

export default {};
